export const CCPA_ANALYTICS = "hs_ccpa_analytics";
export const ACCESSIBILITY = "hs_accessibility";
